import { useBgColorCtx } from '../BgColorProvider'
import { STATUS_FG_COLORS } from '../defaultTheme'
import { TStatusColorKey, TStatusColorKeyOrGrey } from '../typings'
import { getIsGreyishColor } from '../utils'

type TOptions = {
  /**
   * color key for common statuses that can have associated color
   * (error-red, success-green, ...)
   */
  status: TStatusColorKey
}

/**
 * returns themed status color based on requested status and bgColor from closest BgColorProvider
 *
 * ! requires BgColorProvider somewhere above – where the closest bg color is set
 */
export const useStatusFgColorValue = ({ status }: TOptions) => {
  const { bgColorValue, fgColorShade } = useBgColorCtx()

  // for some icons, we use status colors (mostly red/green)
  // these colors should be based affected by the bg color as well
  // also we can use the status colors only when the bg color is greyish
  // if it’s a more saturated color we should use greyish colors for fg instead, to prevent contrast collision (eg. green on yellow bg)
  const isGreyishColor = getIsGreyishColor(bgColorValue)
  const statusKey: TStatusColorKeyOrGrey = isGreyishColor ? status : 'grey'

  return STATUS_FG_COLORS[statusKey][fgColorShade]
}
